/**
 * @ngdoc directive
 * @name phoenix.directive:pxChipsAddOnBlur
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to auto add the value left in the md-chips interface's input to the 
 * array of chips
 *
 * @usage
 *
 * <md-chips px-chips-add-on-blur />
 *
 */
export function ChipsAddOnBlurDirective($interval:ng.IIntervalService) {
	return {
		restrict: 'A',
		require: 'mdChips',
		link: function (scope, element, attrs, chipsCtrl) {
			if (!chipsCtrl) { return; }

			var input = null;
			var interval = $interval(function () {
				input = element.find('input');
				if (input.length === 1) {
					$interval.cancel(interval);
					input[0].addEventListener('blur', addValue);
				}
			}, 50);

			function addValue() {
				if (input.val() !== '') {
					//add to interal items
					chipsCtrl.items.push(input.val());
					//clear the value
					input.val('');
				}
			}

			//clean up
			scope.$on('$destroy', function () {
				if (input && input.length === 1) {
					input[0].removeEventListener('blur', addValue);
				}
			});
		}
	};
}

ChipsAddOnBlurDirective.$inject =  [
	'$interval'
];


// WEBPACK FOOTER //
// ./src/phoenix/components/chipsAddOnBlur/chipsAddOnBlur.ts